import React from 'react'
import "../styles/styles.css"

export default function Contact() {
    return (
        <>
           <h1 style={{textAlign:"center"}}>Sing Up our News Letter</h1>
           {/* <div> */}
             <form action="">
               <input type="text" name="" id="name" placeholder="Enter your Name"/>
               <input type="email" name="" id="email" placeholder="Email"/>
               {/* <textarea name="" id="textarea" cols="30" rows="10" placeholder="Type your message"></textarea> */}
               <input type="submit" name="" id="submit"/>

             </form>
           {/* </div> */}

  
        </>
    )
}